import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import { Fragment } from "react";
import { supportContactContent } from "../../data/content";
import styles from "./support-address.module.css";
var SupportAddress = function() {
    var addressHeading = supportContactContent.addressHeading, _address = supportContactContent.address, organisationName = _address.organisationName, buildingName = _address.buildingName, thoroughfare = _address.thoroughfare, postTown = _address.postTown, postcode = _address.postcode, country = _address.country, companyRegistrationInformation = supportContactContent.companyRegistrationInformation;
    var addressDetails = [
        organisationName,
        buildingName,
        thoroughfare,
        "".concat(postTown, " ").concat(postcode, " ").concat(country),
        companyRegistrationInformation, 
    ];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("section", {
            className: styles.sectionContainer,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.textWrapper,
                    children: /*#__PURE__*/ _jsx(Text, {
                        element: "h2",
                        fontSize: "xxl",
                        fontWeight: "bold",
                        lineHeight: "display",
                        children: addressHeading
                    })
                }),
                /*#__PURE__*/ _jsx("address", {
                    children: addressDetails.map(function(addressDetail) {
                        return /*#__PURE__*/ _jsx(Fragment, {
                            children: /*#__PURE__*/ _jsx(Text, {
                                fontSize: "xs",
                                fontWeight: "book",
                                children: addressDetail
                            })
                        }, addressDetail);
                    })
                })
            ]
        })
    });
};
export default SupportAddress;
